<template>
  <div style="position: relative;" @click="isShowingUserInfoBoard = true">
    <svg
      t="1508738709248"
      class="screenfull-svg"
      viewBox="0 0 128 128"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      p-id="2069"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      width="128px"
      height="128px"
      @click="click"
    >
      <g id="图层_2">
        <g>
          <path
            fill="#2F3133"
            d="M103.859,81.787c-2.409-1.991-4.82-3.75-7.45-5.391c-5.15-3.164-10.63-5.506-16.438-7.146
			c10.959-6.093,18.411-18.397,18.411-32.458C98.382,16.522,82.932,0,63.972,0C45.014,0,29.563,16.404,29.563,36.793
			c0,14.061,7.452,26.365,18.41,32.574C24.302,75.813,5.235,96.2,0.084,122.447c-0.438,2.227,0.877,4.335,2.959,4.804
			c0.219,0.117,0.548,0.117,0.767,0.117c1.753,0,3.397-1.287,3.726-3.281c5.589-28.239,29.259-48.862,56.327-48.862
			c10.083,0,19.946,2.813,28.711,8.205c2.301,1.405,4.492,3.045,6.574,4.687c1.644,1.405,4.055,1.054,5.369-0.704
			C105.833,85.771,105.613,83.193,103.859,81.787L103.859,81.787z M37.233,36.793c0-15.819,12.055-28.591,26.738-28.591
			c14.685,0,26.739,12.772,26.739,28.591c0,15.818-12.056,28.59-26.739,28.59S37.233,52.495,37.233,36.793L37.233,36.793z"
          />
          <path
            fill="#409EFF"
            d="M107.479,95.848c0,2.461,1.864,4.454,4.164,4.454c2.299,0,4.164-1.993,4.164-4.454
			c0-2.457-1.865-4.451-4.164-4.451C109.343,91.396,107.479,93.391,107.479,95.848L107.479,95.848z"
          />
          <path
            fill="#409EFF"
            d="M115.258,108.621c0,2.459,1.864,4.452,4.164,4.452c2.301,0,4.164-1.993,4.164-4.452
			c0-2.46-1.863-4.453-4.164-4.453C117.122,104.168,115.258,106.161,115.258,108.621z"
          />
          <path
            fill="#409EFF"
            d="M119.422,122.8c0,2.458,1.864,4.451,4.164,4.451c2.301,0,4.164-1.993,4.164-4.451
			c0-2.46-1.863-4.454-4.164-4.454C121.286,118.346,119.422,120.34,119.422,122.8z"
          />
        </g>
      </g>
    </svg>
    <div v-show="isShowingUserInfoBoard" style="position:fixed; right:50px; z-index:99999;min-width: 240px; min-height: 270px; border: 1px solid #e1e1e1; background-color: white; font-size: 13px; display: flex;">
      <div style="position: absolute; top:4px; right:4px; cursor:pointer;" @click="dismissUserInfoBoard"><i class="el-icon-close" style="font-size:20px;" /></div>
      <!--<div style="width:130px; text-align:center;padding:15px;">-->
      <!--<div style="width: 70px; height: 70px;margin:0 auto;border:1px solid #e1e1e1" />-->
      <!--<div style="margin-top: 10px;"><el-button type="primary" size="mini">账户详情</el-button></div>-->
      <!--<div style="margin-top: 10px;"><el-button type="primary" size="mini" @click="$emit('change-password-from-user-info-because-of-shit')">修改密码</el-button></div>-->
      <!--</div>-->
      <div style="border-left:1px solid #e1e1e1;padding:15px;">
        <div style="display: flex">
          <div style=""><img src="/static/avatar.svg" style="width:70px;height:70px;"></div>
          <div style="margin-top:30px; display: flex"> <span style="font-size: 16px;">{{ userInfo.chineseName }}</span></div>
        </div>
        <div style="margin-top:16px; display: flex"><span style="font-size: 12px;font-weight:bold;width: 40px;margin-left: 4px;">用户:</span> <span style="font-size: 12px; margin-left: 26px;">{{ userInfo.userName }}</span></div>
        <div style="margin-top:16px; display: flex"><span style="font-size: 12px;font-weight:bold;width: 40px;margin-left: 4px;">部门:</span> <span style="font-size: 12px; margin-left: 26px;">{{ userInfo.departmentName }}</span></div>
        <div style="margin-top:16px; display: flex"><span style="font-size: 12px;font-weight:bold;width: 40px;margin-left: 4px;">公司:</span> <span style="font-size: 12px; margin-left: 26px; min-width:170px;">{{ userInfo.officeName }}</span></div>
        <div style="margin-top:16px; display: flex"><span style="font-size: 12px;font-weight:bold;width: 40px;margin-left: 4px;">电话:</span>
          <div style="margin-left: 26px;">
            <template v-if="mobileInputVisible">
              <el-input
                ref="mobileInput"
                v-model="mobileNew"
                size="mini"
                @keyup.enter.native="editMobileDo"
                @blur="editMobileDo"
              />
            </template>
            <template v-else>
              <span style="font-size: 12px;">{{ userInfo.mobile }}</span>
            </template>
            <span v-if="!mobileInputVisible" style="cursor:pointer;" @click="toEditMobile">
              <i class="el-icon-edit" style="color:#46a6ff" />
            </span>
          </div>
        </div>
        <div style="margin-top:16px; display: flex"><span style="font-size: 12px;font-weight:bold;width: 40px;margin-left: 4px;">邮箱:</span>
          <!--<div>{{ userInfo.email }} <span style="cursor:pointer;" @click="toEditEmail"><i class="el-icon-edit" style="color:#46a6ff"/></span></div>-->
          <div style="margin-left: 26px;">
            <template v-if="emailInputVisible">
              <el-input
                ref="emailInput"
                v-model="emailNew"
                size="mini"
                @keyup.enter.native="editEmailDo"
                @blur="editEmailDo"
              />
            </template>
            <template v-else>
              <span style="font-size: 12px;">{{ userInfo.email }}</span>
            </template>
            <span v-if="!emailInputVisible" style="cursor:pointer;" @click="toEditEmail">
              <i class="el-icon-edit" style="color:#46a6ff" />
            </span>
          </div>
        </div>
        <div style="display: flex; justify-content: flex-end;margin-top: 18px;">
          <div style=""><el-button type="primary" size="mini" @click="$emit('change-password-from-user-info-because-of-shit')">修改密码</el-button></div>
          <div style="margin-left:10px;"><el-button type="primary" size="mini">查看更多</el-button></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { setUserInfo, getUserInfo } from '@/utils/auth'

export default {
  name: 'Screenfull',
  props: {
    width: {
      type: Number,
      default: 22
    },
    height: {
      type: Number,
      default: 22
    },
    fill: {
      type: String,
      default: '#48576a'
    }
  },
  data() {
    return {
      userInfo: {},
      mobileNew: '',
      mobileInputVisible: false,
      emailNew: '',
      emailInputVisible: false,
      isShowingUserInfoBoard: false,
      isFullscreen: false
    }
  },
  created() {
    this.userInfo = getUserInfo()
  },
  methods: {
    click() {},
    toEditMobile() {
      this.mobileNew = this.userInfo.mobile
      this.mobileInputVisible = true
      this.$nextTick(_ => {
        this.$refs.mobileInput.focus()
      })
    },
    editMobileDo() {
      if (this.mobileNew !== '') {
        this.userInfo.mobile = this.mobileNew
        setUserInfo(this.userInfo)
      }
      this.mobileInputVisible = false
    },
    toEditEmail() {
      this.emailNew = this.userInfo.email
      this.emailInputVisible = true
      this.$nextTick(_ => {
        this.$refs.emailInput.focus()
      })
    },
    editEmailDo() {
      if (this.emailNew !== '') {
        this.userInfo.email = this.emailNew
        setUserInfo(this.userInfo)
      }
      this.emailInputVisible = false
    },
    dismissUserInfoBoard(event) {
      this.isShowingUserInfoBoard = false
      event.stopPropagation() // 要阻止传递，不然会触发最外层div的click于是isShowingUserInfoBoard又成true
    }
  }
}
</script>

<style scoped>
  .screenfull-svg {
    display: inline-block;
    cursor: pointer;
    fill: #35628a;
    width: 20px;
    height: 20px;
    vertical-align: 10px;
  }
</style>
